import { PersonnelData } from '../../model/personnel-data';
import { PerEmployeeCardsModel } from '../model/per-employee-cards-model';
import { HrAuthority } from '../../constant/authority/hr-authority';
import { HvlSecurityService } from '@hvlng/framework-bff/security';
import { PerEmployeeCardAuthorityModel } from './employee-card-authority-model';
import { SelectedItemAuthorityModel } from './selected-item-authority-model';
import { AuthorizedEmployeeCardModel } from '../model/authorized-employee-card-model';

export class PerEmployeeCardAuthorityManager {
    static getAuthorities(
        securityService: HvlSecurityService,
        personnel: PersonnelData,
        personnelCardCode: string,
        cardManagerAuthority?: string,
    ): PerEmployeeCardAuthorityModel {
        const cardInfo: PerEmployeeCardsModel = personnel.cardInfoList.find(
            (it) => it.employeeCard.code === personnelCardCode,
        );

        let cardCode = personnelCardCode;
        // sicil hareketi kartı için satır bazlı yetkiler movement olarak veriliyor.
        // Bu yüzden burada işçiye özel movement-private kartı için yetki kontrolünün movement olarak yapılması sağlanıyor.
        if (cardCode === 'movement-private')
            cardCode = 'movement';

        console.log('authorizedCard: ' + cardCode);

        let authorizedCard = personnel.authorizedCards?.find((p) => p.employeeCardCode === cardCode);
        if (!authorizedCard) {
            authorizedCard = {
                employeeCardCode: '',
                canRead: false,
                canEdit: false,
                hrmTypeLimitations: [],
                canView: false,
            };
            console.log('authorizedCard: C1');
        }

        if (!cardInfo?.cardUsage) {
            console.log('authorizedCard: C2');
            return new PerEmployeeCardAuthorityModel(false, false, false, false,
                cardInfo?.isVisibleToEmployee, false, [], authorizedCard);
        }

        if (!securityService.isSecurityActive) {
            console.log('authorizedCard: C3');
            return new PerEmployeeCardAuthorityModel(true, true, true, true,
                cardInfo.isVisibleToEmployee, true, [], authorizedCard);
        }

        if (!cardManagerAuthority) {
            cardManagerAuthority = HrAuthority.Personnel.Admin.BASE;
            console.log('authorizedCard: C4');
        }

        let hasHrAdmin = securityService.hasAuthority(cardManagerAuthority);

        // onay süreci olmayan kartlarda HrAdmin yetkisi var herşeyi yapabilir.
        if (!cardInfo.approvalUsage && hasHrAdmin) {
            console.log('authorizedCard: C5');
            return new PerEmployeeCardAuthorityModel(true, true, true, true,
                cardInfo.isVisibleToEmployee, true, [], authorizedCard);
        }

        let hasApproveAdminAuthority = securityService.hasAuthority(HrAuthority.Personnel.MasterApprove.BASE);

        if (!hasApproveAdminAuthority) {
            // approve yetkisi kendisi dışındaki personellerin onaylı verilerine müdahale edebilmesini sağlıyor.
            // Bu yüzden master:approve yetkisi yoksa aşağıdaki kısıtlı yetki kontrolünden geçiriliyor.
            const hasLimitedApproveAuthority = securityService.hasAuthority(HrAuthority.Personnel.Approve.BASE);
            if (hasLimitedApproveAuthority && !personnel.isSessionPersonnel) {
                hasApproveAdminAuthority = true;
                console.log('authorizedCard: C6');
            }
        }

        // onay süreci olan kartlarda HrAdmin ve ApproveAdmin yetkileri varsa herşeyi yapabilir.
        if (cardInfo.approvalUsage && hasHrAdmin && hasApproveAdminAuthority) {
            console.log('authorizedCard: C7');
            return new PerEmployeeCardAuthorityModel(true, true, true, true,
                cardInfo.isVisibleToEmployee, true, [], authorizedCard);
        }


        if (personnel.isSessionPersonnel) {
            // seçili personel login olan kullanıcı ise
            console.log('authorizedCard: C8');
            return new PerEmployeeCardAuthorityModel(
                cardInfo.editSelf || authorizedCard?.canEdit,
                cardInfo.viewSelf || authorizedCard?.canRead,
                false,
                hasApproveAdminAuthority,
                cardInfo.isVisibleToEmployee,
                true,
                [],
                authorizedCard,
            );
        }

        if (personnel.isManagedByLoggedInPersonnel && cardInfo.viewChild) {
            console.log('authorizedCard: C9');
            // login olan kullanıcı seçili personelin yöneticisi ise
            return new PerEmployeeCardAuthorityModel(
                authorizedCard?.canEdit,
                cardInfo.viewChild || authorizedCard?.canRead,
                false,
                hasApproveAdminAuthority,
                cardInfo.isVisibleToEmployee,
                true,
                authorizedCard.hrmTypeLimitations,
                authorizedCard,
            );
        }

        console.log('authorizedCard: C10');
        return new PerEmployeeCardAuthorityModel(
            authorizedCard?.canEdit,
            authorizedCard?.canRead,
            false,
            hasApproveAdminAuthority,
            cardInfo.isVisibleToEmployee,
            false,
            authorizedCard.hrmTypeLimitations,
            authorizedCard,
        );
    }

    static checkHrmTypeAuthority(
        hrmTypeUuid: String,
        cardAuthority: PerEmployeeCardAuthorityModel | AuthorizedEmployeeCardModel,
    ): SelectedItemAuthorityModel {
        if (cardAuthority?.hrmTypeLimitations?.length > 0) {
            const auth = cardAuthority.hrmTypeLimitations.find((p) => p.hrmTypeUuid === hrmTypeUuid);
            return new SelectedItemAuthorityModel(auth?.canEdit, auth?.canRead);
        }

        return new SelectedItemAuthorityModel(cardAuthority.canEdit, cardAuthority.canView);
    }

}
